import React, { useState, useEffect , useCallback, useMemo } from "react";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import { ROUTES } from "../../../utilities/constant";
import Loader  from '../../../components/partials/components/loader';
import { errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import { BACKEND_API_BASE_URL, USER_ROLES } from '../../../utilities/constant';
import { getUser } from "../../../utilities/setting";
import "../../../assets/custom/css/custom.css";
import { Dropdown } from 'primereact/dropdown';
import { Panel } from 'primereact/panel';

import { Row, Col, Modal, Button, Form , Card, Table} from 'react-bootstrap';
import { API_USER_LOGOUT_FROM, CALL_GROUP_REMOVE_AGENT, CALL_GROUP_ADD_AGENT, API_BREAK_LIST , API_AGENT_BREAK_ADD, API_AGENT_BULK_LOGOUT} from "../../../service/url";
import Boxes from './boxes';
import { motion } from "framer-motion";
import { getUserAccessToken } from "../../../utilities/setting";
import { Headphones, MessageCircle, Users, LogOut, Pause, Play, UserPlus, UserMinus, ListChecks } from "lucide-react";
import { Storage } from "../../../utilities/setting";

const RealtimeList = () => {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(
    typeof document !== "undefined" && document.body.classList.contains("dark")
  );
  const [statusList, setStatusList] = useState({});
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [realtimeData, setRealTimeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAgentData, setSelectedAgentData] = useState(null);
  const [agentPopupVisible, setAgentPopupVisible] = useState(false);
  const [extension, setExtension] = useState(null);
  const [assignQueueModelView, setAssignQueueModelView] = useState(false);
  const [assignedQueueList, setAssignedQueueList] = useState([]);
  const [selectedQueue, setSelectedQueue] = useState([])
  const [removeQueueModelView, setRemoveQueueModelView] = useState(false);
  const [queueModel, setQueueModel] = useState(false);
  const [queueList, setQueueList] = useState([]);
  const [selectedRemoveQueue, setSelectedRemoveQueue] = useState([]);
  const [wholeDay, setWholeDay] = useState(true);
  const [startTime, setStartTime] = useState("00:00");
  const [endTime, setEndTime] = useState("23:59");
  const [selectedAgentName, setSelectedAgentName] = useState("");
  const [memberWeekDays, setmemberWeekDays] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]);
  const [queueDetail, setQueueDetail] = useState([])
  const [queuePopupVisible, setQueuePopupVisible] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ x: window.innerWidth/2 + 45, y: 350 });
  const [currentTime, setCurrentTime] = useState(Math.floor(Date.now() / 1000));
  const [loggedInUser, setLoggedInUserId] = useState("")
  const [breakList, setBreakList] = useState([])
  const [selectedBreak, setSelectedBreak] = useState("");
  const [breakModelVisible, setBreakModelVisible] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false);


  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const body = document.body;
    const updateTheme = () => setIsDarkMode(body.classList.contains("dark"));
    const observer = new MutationObserver(updateTheme);

    updateTheme();
    observer.observe(body, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

    useEffect(() => {
      async function loggedInUser() {
        const rawUser = Storage.getItem('user');
        if (!rawUser) {
          console.error("User not found in Storage");
          return null;
        }
        let user;
        try {
          user = JSON.parse(rawUser);
        } catch (e) {
          console.error("Invalid JSON in user from Storage", e);
          return null;
        }
        setLoggedInUserId(user.role);
      }
  
      loggedInUser();
    }, []);

    useEffect(() => {
        getApiCall(API_BREAK_LIST)
            .then((data) => {
                const options = data.map((dataOpt) => ({
                    label: dataOpt.title,
                    value: dataOpt.id,
                }));
               
                setBreakList(options);
            })
            .catch((error) => {
                console.error('Error fetching Breaks:', error);
            });
    }, []);


  useEffect(() => {
    localStorage.setItem("queuePopupPosition", JSON.stringify(popupPosition));
  }, [popupPosition]);

  useEffect(() => {
    const savedPosition = JSON.parse(localStorage.getItem("queuePopupPosition"));
    if (savedPosition) {
      setPopupPosition(savedPosition);
    }
  }, []);

const fetchRealtimeData = useCallback(() => {
  const token = getUserAccessToken();
    const es = new EventSource(`${BACKEND_API_BASE_URL}/v2/agents/real-time?token=${token}`);
    let firstMessage = true;

    es.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const arrayData = Array.isArray(data.data) ? data.data : [data.data];
      setRealTimeData(arrayData[0].agents);
      setQueueDetail(arrayData[0].queues);

      if (firstMessage) {
        setLoading(false);  
        firstMessage = false;
      }
    };

    es.onerror = () => {
      es.close();
      setLoading(false);
    };

    return es;
}, []); 


useEffect(() => {
  setLoading(true);
  let eventSource;
  const token = getUserAccessToken();

  // getUserAccessToken().then(token => {
    eventSource = new EventSource(`${BACKEND_API_BASE_URL}/v2/agents/real-time?token=${token}`);
    let firstMessage = true;

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      const arr = Array.isArray(data.data) ? data.data : [data.data];
      setRealTimeData(arr[0].agents);
      setQueueDetail(arr[0].queues);
      if (firstMessage) { setLoading(false); firstMessage = false; }
    };

    eventSource.onerror = () => { eventSource.close(); setLoading(false); };
  // });

  return () => { if (eventSource) eventSource.close(); };
}, []);

 
  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);



   const filteredData = useMemo(() => {
  if (!searchText) return realtimeData; 
  const lower = searchText.toLowerCase();
  return realtimeData.filter(item => {
    const name = item?.agent?.agent_name?.toLowerCase() || "";
    const profiles = item?.agent?.agentTelephony?.profile || [];
    const activeProfile = profiles.find(p => p.active_profile === true);
    const number = activeProfile?.number?.number?.toString() || "";
    return name.includes(lower) || number.includes(searchText);
  });
}, [realtimeData, searchText]);



    if (loading) {
      return <Loader />
  }

  const handleRowClick = (rowData) => {
    setAssignedQueueList(rowData?.noAssignedGroup)
    setQueueList(rowData?.agentGroup)


    const profiles = rowData?.agent?.agentTelephony?.profile || [];
    const activeProfile = profiles.find(p => p.active_profile === true);
    const extensionNumber = activeProfile?.number?.number || '-';
    setExtension(extensionNumber)
    setSelectedAgentData(rowData);
    setAgentPopupVisible(true);
  };

    const handleLogoutAgent = (selectedAgentData) => {
      if (!selectedAgentData?.agent?.id) {
        toast.error('Agent Id Not Found To Process');
        return;
      }
      postApiCall(`${API_AGENT_BULK_LOGOUT}`, { agentIds: [selectedAgentData?.agent?.id] })
        .then((resp) => {
          toast.success('Agent Logout Successfully')
          setAgentPopupVisible(false)
        })
        .catch(error => {
            toast.warning(`Failed Agent Logout: ${error}`)
            setAgentPopupVisible(false)
        })
    };

    const handleRemoveQueueClick = () => {
      setRemoveQueueModelView(true)
    };

    const handleRemoveQueue = () => {
      const params = {
        agent_id : selectedAgentData?.agent?.id
      }
      postApiCall(`${CALL_GROUP_REMOVE_AGENT}/${selectedRemoveQueue}` , params)
        .then((resp) => {
           toast.success('Agent Removed Successfully')
          setRemoveQueueModelView(false)
          setSelectedRemoveQueue('')
          setAgentPopupVisible(false)
        })
        .catch(error => {
            toast.warning(`Failed Agent Removal: ${error}`)
            setRemoveQueueModelView(false)
      })
    };

    const handleWholeDayChange = (e) => {
      const isChecked = e.target.checked;
      setWholeDay(isChecked);
  
      if (isChecked) {
          setStartTime("00:00");
          setEndTime("23:59");
      } else {
          setStartTime("");
          setEndTime("");
      }
  };
  
  const handleStartTimeChange = (e) => {
      if (!wholeDay) {
          setStartTime(e.target.value);
      }
  };
  
  const handleEndTimeChange = (e) => {
      if (!wholeDay) {
          setEndTime(e.target.value);
      }
  };

  const toMinutes = (timeValue) => {
    if (!timeValue || !String(timeValue).includes(":")) return NaN;
    const [hours, minutes] = String(timeValue).split(":").map(Number);
    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return NaN;
    return (hours * 60) + minutes;
  };

  const handleAddQueueClick = () => {
    setAssignQueueModelView(true)
  };

  const handleAddBreakClick = () => {
    setBreakModelVisible(true)
  };

  const handleAddQueue = () => {
    if (!wholeDay) {
      if (!startTime || !endTime) {
        toast.warning("Please select both start time and end time");
        return;
      }

      const startMins = toMinutes(startTime);
      const endMins = toMinutes(endTime);

      if (!Number.isFinite(startMins) || !Number.isFinite(endMins)) {
        toast.warning("Invalid time selected");
        return;
      }

      if (memberWeekDays.length === 1 && endMins <= startMins) {
        toast.warning("For a single selected day, end time should be greater than start time");
        return;
      }
    }

    const params = {
      agent_id : [selectedAgentData?.agent?.id],
      type:'add_member',
      memberSchedulePayload: {
        week_days: memberWeekDays,
        start_time: startTime,
        end_time: endTime,
      }
    }

    postApiCall(`${CALL_GROUP_ADD_AGENT}/${selectedQueue}` , params)
      .then((resp) => {
           toast.success('Agent Added Successfully')
        setAssignQueueModelView(false)
        setSelectedQueue('')
        setAgentPopupVisible(false)
      })
      .catch(error => {
           toast.warning(`Failed Agent Addition: ${error}`)
          setAssignQueueModelView(false)
    })
  };

  const formatDuration = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return `${h > 0 ? String(h).padStart(2, "0") + ":" : ""}${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  const handleAddBreak = () => {
    const params = {
      break_id : selectedBreak,
      break: 'Added'
    }

    postApiCall(`${API_AGENT_BREAK_ADD}/${selectedAgentData?.agent?.id}` , params)
      .then(async (resp) => {
            toast.success(`Break Added Successfully`)
        setBreakModelVisible(false)
        setSelectedBreak('')
        setAgentPopupVisible(false)
        await fetchRealtimeData();

      })
      .catch(error => {
           toast.warning(`Failed Break Addition: ${error}`)
          setBreakModelVisible(false)
    })
  };

  const handleRemoveBreak = () => {
    const params = {
      break_id : null,
      break: 'Removed'
    }

    postApiCall(`${API_AGENT_BREAK_ADD}/${selectedAgentData?.agent?.id}` , params)
      .then(async (resp) => {
            toast.success(`Break Removed Successfully`)
        setAgentPopupVisible(false)
        await fetchRealtimeData();
      })
      .catch(error => {
        toast.warning(`Failed Break Removal: ${error}`)
    })
  };

  const handleOpenConfirm = () => {
    setShowConfirm(true);
  };

  const handleCloseConfirm = () => {
    setShowConfirm(false);
  };

  const handleConfirmRemoveBreak = () => {
    handleRemoveBreak();
    setShowConfirm(false);
  };




  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Real-Time</h4>
              </div>
             
                
            </Card.Header>
              <Card.Body className="px-0">
                <Boxes realtimeData={realtimeData} setQueuePopupVisible={setQueuePopupVisible} queueDetail={queueDetail} loggedInUser={loggedInUser}/>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <h4 className="card-title mb-0">Real-Time</h4>
                  <input
                    type="text"
                    placeholder="Search by name..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      width: "250px",
                      fontSize: "13px"
                    }}
                  />
                </div>
                <div className="table-responsive border-bottom my-3">
                  <div className="scroll-container">
                    <DataTable
                      value={filteredData}
                      tableStyle={{ minWidth: "50rem" }}
                      paginator
                      rows={8}
                      onRowClick={(e) => handleRowClick(e.data)}
                      selectionMode="single"
                    >
                    <Column
                      header="Agent Name"
                      body={(rowData) => {
                        const agentName = rowData?.agent?.agent_name || '-';
                        const profiles = rowData?.agent?.agentTelephony?.profile || [];

                        const renderToggle = (type) => {
                          const profile = profiles.find(p => p.type === type);
                          const isActive = !!profile?.active_profile;
                          const label = type.toUpperCase();

                          return (
                            <div
                              key={type}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                marginBottom: '4px'
                              }}
                            >
                              {/* Toggle Indicator */}
                              <div
                                style={{
                                  width: '32px',
                                  height: '18px',
                                  borderRadius: '12px',
                                  backgroundColor: isActive ? '#52c41a' : '#ff4d4f',
                                  position: 'relative',
                                  transition: 'background-color 0.3s ease'
                                }}
                              >
                                <div
                                  style={{
                                    width: '14px',
                                    height: '14px',
                                    background: '#fff',
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    top: '2px',
                                    left: isActive ? '16px' : '2px', // Move thumb based on active state
                                    transition: 'left 0.3s ease'
                                  }}
                                />
                              </div>
                              {/* Label */}
                              <span style={{ fontSize: '12px', fontWeight: 500 }}>{label}</span>
                            </div>
                          );
                        };

                        return (
                          <div>
                            <div style={{ fontWeight: 'bold', marginBottom: '6px' }}>{agentName}</div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              {['Mobile', 'Soft Phone', 'WEBRTC'].map(type => renderToggle(type))}
                            </div>
                          </div>
                        );
                      }}
                    />


                      <Column
                        header="Call Status"
                        body={(rowData) => {
                          const callStatus = rowData?.agent?.call_status;
                          if (callStatus === null || callStatus === undefined) {
                            return "-"
                          }
                          if (callStatus == 0) {
                            return "Not in a Call";
                          } else if (callStatus == 1) {
                            return "In Call";
                          }
                        }}
                      />
                      <Column
                        header="Log In"
                        body={(rowData) => {
                          const loginAt = rowData?.user?.login_at;

                          return loginAt
                            ? new Date(loginAt).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              })
                            : "-";
                        }}
                      />
                      <Column
                        header="Log Out"
                        body={(rowData) => {
                          if (rowData.user.logout_at) {
                            return new Date(rowData.user.logout_at).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                           })
                          }
                        }
                      }
                      />
                      <Column
                        header="Extension/Number"
                        body={(rowData) => {
                          const profiles = rowData?.agent?.agentTelephony?.profile;
                          const activeProfile = profiles?.find(p => p.active_profile === true);
                          return activeProfile?.number?.number || '-';
                        }}
                      />
                       <Column
                          header="Queue"
                          body={(rowData) => {
                            const names = rowData.agentGroup?.map(group => group.group_name) || [];
                            const grouped = names.reduce((acc, name, index) => {
                              const lineIndex = Math.floor(index / 2);
                              if (!acc[lineIndex]) acc[lineIndex] = [];
                              acc[lineIndex].push(name);
                              return acc;
                            }, []);
                            return grouped.length > 0 ? (
                              <button
                                onClick={() => {
                                  setAssignedQueueList(...grouped);
                                  setQueueModel(true);
                                  setSelectedAgentName(rowData?.agent?.agent_name || '-')
                                }}
                                style={{
                                  background: isDarkMode
                                    ? "linear-gradient(135deg, #1e3a8a, #1e40af)"
                                    : "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                                  border: isDarkMode
                                    ? "none"
                                    : "1px solid rgba(37, 99, 235, 0.24)",
                                  borderRadius: "999px",
                                  padding: "6px 14px",
                                  cursor: "pointer",
                                  fontSize: "13px",
                                  color: isDarkMode ? "#fff" : "#1e3a8a",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  boxShadow: isDarkMode
                                    ? "0 4px 10px rgba(30, 58, 138, 0.35)"
                                    : "0 4px 12px rgba(37, 99, 235, 0.12)",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <ListChecks size={16} />
                                Assigned Queues
                              </button>
                            ) : null;
                          }}
                        />


                      <Column
                        header="Status"
                        body={(rowData) => {
                          const status = rowData?.agent?.login_status === "1";
                          return (
                            <span
                                key={status}
                                style={{
                                  marginRight: '4px',
                                  padding: '5px 10px',
                                  borderRadius: '999px',
                                  backgroundColor: isDarkMode
                                    ? (status ? '#16a34a' : '#ef4444')
                                    : (status ? '#dcfce7' : '#fee2e2'),
                                  color: isDarkMode
                                    ? '#ffffff'
                                    : (status ? '#166534' : '#b91c1c'),
                                  fontSize: '12px',
                                  fontWeight: 600,
                                  border: isDarkMode
                                    ? 'none'
                                    : `1px solid ${status ? 'rgba(34, 197, 94, 0.3)' : 'rgba(239, 68, 68, 0.28)'}`,
                                }}
                              >
                                {status ? 'Online' : 'Offline'}
                              </span>
                          );
                        }}
                      />
                      {/* <Column
                        header="Activity"
                        body={() => {
                          // Static values for now
                            const statusItems = [
                            // { label: 'Microsip', bgColor: '#ef4444', color: 'white' },
                            {
                              label: 'Idle',
                              bgColor: isDarkMode ? '#16a34a' : '#dcfce7',
                              color: isDarkMode ? '#ffffff' : '#166534'
                            },
                            {
                              label: '2064:45:39',
                              bgColor: isDarkMode ? '#16a34a' : '#dcfce7',
                              color: isDarkMode ? '#ffffff' : '#166534'
                            },
                          ];

                          return (
                            <div className="flex flex-col gap-1">
                              {statusItems.map((item, index) => (
                                <span
                                  key={index}
                                  style={{
                                    display: 'block',
                                    padding: '4px 8px',
                                    borderRadius: '20px',
                                    backgroundColor: item.bgColor,
                                    color: item.color,
                                    fontWeight: 600,
                                    textAlign: 'center',
                                    fontSize: '11px',
                                    marginTop: '2px',
                                    whiteSpace: 'nowrap',
                                    maxWidth: '72px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    border: isDarkMode ? 'none' : '1px solid rgba(34, 197, 94, 0.3)',
                                  }}
                                >
                                  {item.label}
                                </span>
                              ))}
                            </div>
                          );
                        }}
                      /> */}
                    </DataTable>
                  </div>  
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Modal
          show={agentPopupVisible}
          onHide={() => setAgentPopupVisible(false)}
          dialogClassName="w-100"
          centered
        >
          <div style={{
            maxWidth: '500px',
            opacity: removeQueueModelView ? 0.1 : 1,
            pointerEvents: removeQueueModelView ? 'none' : 'auto',
            transition: 'opacity 0.3s ease-in-out',
          }}>
          <Modal.Header closeButton>
            <Modal.Title>User Info</Modal.Title>
          </Modal.Header>
          
          <Modal.Body>
            <div className="agent-popup-content">
              <div className="d-flex align-items-center mb-3">
                <div className="info-icon-list">
                  <span className="popup-info-icon">
                    <i className="icon-user"></i>
                  </span>
                  <span>Role:   <b>Agent</b></span>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <div className="info-icon-list">
                  <span className="popup-info-icon">
                    <i className="icon-user"></i>
                  </span>
                  <span>Extension: </span>
                </div>
                <div className="list-info">
                  <b>{extension}</b>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="flex-column align-items-start">
            <div className="button-group w-100">
              <div className="button-row d-flex  mb-2">
                <Button className="btn btn-primary" style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }} disabled={!selectedAgentData?.agent?.call_status || selectedAgentData?.agent?.call_status == "0"}>
                  <Headphones size={18} />
                  Listen
                </Button>
                <Button className="btn btn-primary" style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }} disabled={!selectedAgentData?.agent?.call_status || selectedAgentData?.agent?.call_status == "0"}>
                  <MessageCircle size={18} />
                  Whisper
                </Button>
                <Button className="btn btn-primary" style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }} disabled={!selectedAgentData?.agent?.call_status || selectedAgentData?.agent?.call_status == "0"}>
                  <Users size={18} />
                  Conference
                </Button>
                <Button 
                  className="btn btn-primary" 
                  // disabled={selectedAgentData?.agent?.login_status === "0"} 
                  onClick={() => handleLogoutAgent(selectedAgentData)}
                  style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }}
                >
                  <LogOut size={18} />
                  Logout
                </Button>


              </div>
              <div className="button-row d-flex  mb-2">
                {/* <Button 
                  className="btn btn-primary" 
                  style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }}
                  onClick={()=> handleAddBreakClick()}
                  disabled={selectedAgentData?.agent?.break_id !== null} 
                >
                  <Pause size={18} />
                  Set Break
                </Button> */}

                {/* <Button 
                  className="btn btn-primary"
                  style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }}
                  disabled={selectedAgentData?.agent?.break_id === null}
                  onClick={handleOpenConfirm}
                >
                  <Play size={18} />
                  Remove Break
                </Button> */}

                <Button 
                  className="btn btn-primary" 
                  style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }} 
                  onClick={() => handleAddQueueClick()}
                >
                  <UserPlus size={18} />
                  Add to Queue
                </Button>
              </div>
              <div className="button-row d-flex ">
                <Button 
                  className="btn btn-primary" 
                  style={{ marginRight: '10px', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 10px', fontSize: '13px' }} 
                  onClick={() => handleRemoveQueueClick()}
                >
                  <UserMinus size={18} />
                  Remove From Queue
                </Button>
              </div>
            </div>
          </Modal.Footer>
          </div>
         
        </Modal>
           {/* Remove from Queue model */}
            <Modal show={removeQueueModelView} 
              onHide={() => {
                setRemoveQueueModelView(false);
                setSelectedRemoveQueue("");
                setAgentPopupVisible(false)
              }} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Remove Queue</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Dropdown
                        value={selectedRemoveQueue}
                        options={queueList?.map(group => ({
                          label: group.group_name,
                          value: group.id
                        }))}
                        onChange={(e) => setSelectedRemoveQueue(e.value)}
                        placeholder="Select Queue"
                        className="w-100"
                        appendTo="self"
                      />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button label="Close" className="p-button-secondary" style={{ marginRight: '10px' }} onClick={() => {
                        setRemoveQueueModelView(false);
                        setSelectedRemoveQueue("");
                        setAgentPopupVisible(false)
                      }} >Close </Button>
                        <Button label="Remove" className="p-button-primary" onClick={() => handleRemoveQueue()}>Remove</Button>
                    </Modal.Footer>
                </Modal>

          {/* Add In Queue Modal */}
            <Modal show={assignQueueModelView} onHide={()=> {setAssignQueueModelView(false); setSelectedQueue(""); setAgentPopupVisible(false)}} size="lg" centered>
                <Modal.Header closeButton >
                    <Modal.Title>Add Queue</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Row>
                        <Col>
                        <label style={{ marginBottom: '10px'}}>Select Queue:</label>
                          <Dropdown
                          value={selectedQueue}
                          options={assignedQueueList.map(group => ({
                            label: group.group_name,
                            value: group.id
                          }))}
                          onChange={(e) => setSelectedQueue(e.value)}
                          placeholder="Select Queue"
                          className="w-100"
                          appendTo="self"
                          style={{ marginBottom: '20px'}}
                        />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Form>
                            {/* Whole Day Checkbox */}
                            <Form.Check
                                type="checkbox"
                                label="Whole Day"
                                id="wholeDay"
                                className="mb-3"
                                checked={wholeDay}
                                onChange={handleWholeDayChange}
                            />

                            {/* Start Time */}
                            <Form.Group className="mb-3">
                                <Form.Label>Start Time</Form.Label>
                                <Form.Control
                                    type="time"
                                    value={startTime}
                                    placeholder="00:00"
                                    disabled={wholeDay}
                                    onChange={handleStartTimeChange}
                                />
                            </Form.Group>

                            {/* End Time */}
                            <Form.Group className="mb-3">
                                <Form.Label>End Time</Form.Label>
                                <Form.Control
                                    type="time"
                                    value={endTime}
                                    placeholder="23:59"
                                    disabled={wholeDay}
                                    onChange={handleEndTimeChange}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                    <Form.Label>Select Days</Form.Label>
                                    <div>
                                        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(
                                            (day) => (
                                                <Form.Check
                                                    inline
                                                    key={day}
                                                    label={day}
                                                    type="checkbox"
                                                    checked={memberWeekDays.includes(day)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setmemberWeekDays((prev) => [...prev, day]);
                                                        } else {
                                                            setmemberWeekDays((prev) => prev.filter((d) => d !== day));
                                                        }
                                                    }}
                                                />
                                            )
                                        )}
                                    </div>
                                </Form.Group>
                        </Form>
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={()=> {setAssignQueueModelView(false); setSelectedQueue("");
                      setAgentPopupVisible(false)}}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddQueue}>Add</Button>
                </Modal.Footer>
            </Modal>

      </div>
                <Modal
                    show={queueModel}
                    onHide={() => setQueueModel(false)}
                    centered
                    >
                    <Modal.Header closeButton>
                        <Modal.Title style={{ fontSize: '22px' }}>Queues Allocated to: {selectedAgentName}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {assignedQueueList.length > 0 ? (
                        <div>
                          <div style={{ marginBottom: '10px' }}>
                            {/* <strong>Assigned Queues:</strong> */}
                            <ul style={{paddingLeft: '16px' }}>
                              {assignedQueueList.map((queue, index) => (
                                <li key={index}>{queue}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ) : (
                        <div>No Queue Allocated.</div>
                      )}
                    </Modal.Body>
                </Modal>

                {queuePopupVisible && (
                  <motion.div
                    className="queue-info-popup shadow-lg"
                    drag
                    dragElastic={0.2}
                    dragMomentum={false}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      position: 'fixed',
                      top: '10%', 
                      left: '50%', 
                      transform: 'translateX(-50%)',
                      width: '550px',
                      background: isDarkMode ? '#111827' : '#fff',
                      borderRadius: '12px',
                      boxShadow: isDarkMode
                        ? '0 18px 40px rgba(2,6,23,0.45)'
                        : '0 4px 20px rgba(0,0,0,0.15)',
                      border: isDarkMode ? '1px solid rgba(148, 163, 184, 0.18)' : 'none',
                      zIndex: 9999,
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                    onDragEnd={(event, info) => {
                      setPopupPosition(prev => ({
                        x: prev.x + info.offset.x,
                        y: prev.y + info.offset.y,
                      }));
                    }}
                  >
                    {/* Header */}
                    <div
                      className="queue-popup-header d-flex justify-content-between align-items-center p-3"
                      style={{
                        backgroundColor: isDarkMode ? '#0f172a' : 'rgba(8, 50, 105, 1)',
                        color: '#fff',
                        borderTopLeftRadius: '12px',
                        borderTopRightRadius: '12px'
                      }}
                    >
                      <h5 className="mb-0" style={{ fontWeight: 600 }}>Queue Info</h5>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setQueuePopupVisible(false);
                        }}
                        style={{
                          fontSize: '18px',
                          textDecoration: 'none',
                          color: '#fff',
                          fontWeight: 'bold'
                        }}
                      >
                        ✖
                      </a>
                    </div>

                    {/* Scrollable Content */}
                    <div
                      className="queue-popup-content"
                      style={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        padding: '15px',
                        background: isDarkMode ? '#111827' : '#fff',
                        color: isDarkMode ? '#e5e7eb' : '#111827'
                      }}
                    >
                      {queueDetail?.queueData
                        .filter(queue => Object.keys(queue.value).length > 0)
                        .map((queue, index) => {
                          const queueName = queue.key.split(':')[3];
                          const calls = Object.values(queue.value);

                          return (
                            <div key={index} className="mb-4">
                              {/* Queue Name */}
                              <h6 className="fw-bold mb-2" style={{ color: isDarkMode ? '#93c5fd' : 'rgba(8, 50, 105, 1)' }}>{queueName}</h6>

                              {/* Styled Table */}
                              <div
                                style={{
                                  overflow: 'hidden',
                                  borderRadius: '8px',
                                  border: isDarkMode ? '1px solid rgba(148, 163, 184, 0.18)' : '1px solid #e0e0e0',
                                  boxShadow: isDarkMode
                                    ? '0 6px 18px rgba(2,6,23,0.22)'
                                    : '0 2px 6px rgba(0,0,0,0.05)'
                                }}
                              >
                                <Table
                                  bordered
                                  size="sm"
                                  style={{
                                    backgroundColor: isDarkMode ? '#111827' : '#fff',
                                    width: '100%',
                                    borderCollapse: 'separate',
                                    borderSpacing: '0',
                                    margin: 0,
                                    color: isDarkMode ? '#e5e7eb' : '#111827'
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th style={{ backgroundColor: isDarkMode ? '#0f172a' : '#f9f9f9', color: isDarkMode ? '#f8fafc' : '#111827', fontWeight: 600 }}>Customer Number</th>
                                      <th style={{ backgroundColor: isDarkMode ? '#0f172a' : '#f9f9f9', color: isDarkMode ? '#f8fafc' : '#111827', fontWeight: 600 }}>Enqueue Time</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {calls.map((call, idx) => {
                                      const enqueueSeconds = parseInt(call.enqueueTime);
                                      const diff = currentTime - enqueueSeconds;

                                      const cellStyle = {
                                        backgroundColor: isDarkMode
                                          ? (idx % 2 === 0 ? '#111827' : '#0f172a')
                                          : (idx % 2 === 0 ? '#f5faff' : '#ffffff'),
                                        color: isDarkMode ? '#e5e7eb' : '#111827',
                                        transition: 'background-color 0.2s ease, color 0.2s ease'
                                      };

                                      return (
                                        <tr
                                          key={idx}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.querySelectorAll('td').forEach(
                                              (td) => {
                                                td.style.backgroundColor = isDarkMode ? '#172554' : '#d9edf7';
                                                td.style.color = isDarkMode ? '#f8fafc' : '#111827';
                                              }
                                            );
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.querySelectorAll('td').forEach(
                                              (td) => {
                                                td.style.backgroundColor = isDarkMode
                                                  ? (idx % 2 === 0 ? '#111827' : '#0f172a')
                                                  : (idx % 2 === 0 ? '#f5faff' : '#ffffff');
                                                td.style.color = isDarkMode ? '#e5e7eb' : '#111827';
                                              }
                                            );
                                          }}
                                        >
                                          <td style={cellStyle}>{call.calleeTo}</td>
                                          <td style={cellStyle}>{formatDuration(diff)}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          );
                        })}
                    </div>

                    {/* Footer */}
                    <div
                      className="queue-popup-footer d-flex justify-content-end p-3 border-top"
                      style={{
                        backgroundColor: isDarkMode ? '#0f172a' : '#f9f9f9',
                        borderTopColor: isDarkMode ? 'rgba(148, 163, 184, 0.18)' : undefined,
                        borderBottomLeftRadius: '12px',
                        borderBottomRightRadius: '12px'
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: 'rgba(8, 50, 105, 1)',
                          color: '#fff',
                          border: 'none',
                          padding: '10px 18px',
                          borderRadius: '6px',
                          fontSize: '14px',
                          fontWeight: 500,
                          cursor: 'pointer',
                          transition: 'background 0.3s ease'
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = 'rgba(8, 50, 105, 1)')}
                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'rgba(8, 50, 105, 1)')}
                        onClick={() => setQueuePopupVisible(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </motion.div>
                )}


           {/* Add Break*/}
            <Modal show={breakModelVisible} 
              onHide={() => {
                setBreakModelVisible(false);
                setSelectedBreak("");
                setAgentPopupVisible(false)
              }} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Break</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Dropdown
                        value={selectedBreak}
                        options={breakList}
                        onChange={(e) => setSelectedBreak(e.value)}
                        placeholder="Select Break"
                        className="w-100"
                        appendTo="self"
                      />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button label="Close" className="p-button-secondary" style={{ marginRight: '10px' }} onClick={() => {
                        setBreakModelVisible(false);
                        setSelectedBreak("");
                        setAgentPopupVisible(false)
                      }} >Close </Button>
                        <Button label="Remove" className="p-button-primary" onClick={() => handleAddBreak()}>Add</Button>
                    </Modal.Footer>
            </Modal>

        <Modal show={showConfirm} onHide={handleCloseConfirm} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove break?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirm}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmRemoveBreak}>
            Remove
          </Button>
        </Modal.Footer>
      </Modal>


    </>
  );
};

export default RealtimeList;
